import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:flex-end;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import '.h{flex:1 0 0;}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.da{z-index:11;}.ssr-plugin'
import { useState, PropsWithChildren } from 'react'
import useMediaQuery from '../useMediaQuery'
import { styled } from 'inlines'
import { MessageBox } from '@app/components/blocks/messageBox/MessageBox'
import {
  MessageBoxContext,
  MessageContext,
  Recipient,
} from './MessageBoxContext'
import { ClientOnly } from '@based/sdk/react'

export const MessageBoxProvider = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const [isMessageBoxRendered, setIsMessageBoxRendered] = useState(false)
  const [messageContext, setMessageContext] = useState<MessageContext>(null)

  const showMessageBox = (
    allRecipients: Recipient[],
    initiativeId: number,
    recipientId: number,
  ) => {
    if (isMessageBoxRendered) {
      return
    }

    setIsMessageBoxRendered(true)
    setMessageContext({
      recipients: allRecipients,
      selectedRecipientId: recipientId,
      initiativeId,
    })
  }

  const closeMessageBox = () => {
    setIsMessageBoxRendered(false)
  }

  const value = { showMessageBox }

  return (
    <MessageBoxContext.Provider value={value}>
      {children}
      <ClientOnly>
        {isMessageBoxRendered && (
          <div className="d e f g h i da"
            style={{
              right: isMobile ? '0.5rem' : '1.5rem',
              left: isMobile ? '0.5rem' : 'auto',
              bottom: isMobile ? '5rem' : '1.5rem',}}
          >
            <MessageBox
              recipients={messageContext?.recipients ?? []}
              initiativeId={messageContext.initiativeId}
              selectedRecipientId={messageContext.selectedRecipientId}
              onClose={closeMessageBox}
            />
          </div>
        )}
      </ClientOnly>
    </MessageBoxContext.Provider>
  )
}
